import React from "react";
import { FplPitch } from "./fpl/FplPitch";
import { armbandsFor } from "./fpl/fplUtils";

// Read-only FPL pitch used to show an opponent's live draft board.
export const PitchView = ({ board, compact = false }) => {
  const xi = board?.xi || [];
  return (
    <div className={compact ? "" : "rounded-xl overflow-hidden"}>
      <FplPitch xi={xi} armbands={armbandsFor(xi)} compact={compact} square={false} testid={compact ? "opp-pitch-mini" : "opp-pitch"} />
    </div>
  );
};

export default PitchView;
